import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { SizeGuidePage } from '../../Common/HelpCenter';
import { SIZE_GUIDE_TITLE, SIZE_GUIDE_ITEMS } from '../Product/sizeGuideData';
import { CATEGORIES } from './faqData';
import { HELP_LABELS, HELP_ROUTES } from './helpConfig';

const ABCSESizeGuide = () => (
  <SizeGuidePage
    Header={Header}
    Footer={Footer}
    brand="ABC"
    title={SIZE_GUIDE_TITLE}
    lede="Hitta rätt mått för alla våra produkter. Alla mått anges i cm."
    items={SIZE_GUIDE_ITEMS}
    categories={CATEGORIES}
    labels={HELP_LABELS}
    routes={HELP_ROUTES}
  />
);

export default ABCSESizeGuide;
